/**
 * Root application component.
 */

import { AuthGuard } from '@/auth/AuthGuard';
import { RefreshProvider } from '@/context/RefreshContext';
import { Dashboard } from '@/pages/Dashboard';

export function App(): JSX.Element {
  return (
    <AuthGuard>
      <RefreshProvider>
        <Dashboard />
      </RefreshProvider>
    </AuthGuard>
  );
}
